<div class="container">
  <mat-dialog-content class="dialog-content">
    <div style="text-align: right">
      <button mat-icon-button (click)="onNoClick()">
        <mat-icon style="color: rgb(0, 0, 0)">clear</mat-icon>
      </button>
    </div>
    <div class="thanking-popup">
      <div class="shape">
        <img
          class="popup_shape"
          src="https://res.cloudinary.com/dichgutd0/image/upload/v1710652969/EL-Core-Assets/Static/thanking_popup_group_sscjnm.svg"
          alt="popup-image"
        />
      </div>
      <h1 class="thanking-popup__topic el-font-popup-heading">
        {{ data.title }}
      </h1>
      <p class="thanking-popup__paragraph el-font-popup-sub-heading">
        {{ data.sub_title }}
      </p>
      <el-button
        name="Return to Home"
        class="thanking-popup__return-btn"
        [isFilled]="true"
        innerClass="thanking-popup__button"
        [isFocusEnabled]="false"
        [isReverseButtonEnabled]="true"
        (click)="onReturn()"
      ></el-button>
    </div>
  </mat-dialog-content>
</div>
